import React from 'react';
import IntroductionAudio from '../../lesson/IntroductionAudio';

const ExamIntroPage = ({ page }) => {
  return (
    <div>
      
      {page.title && (
        <h1 className="text-3xl font-bold mb-6 text-gray-800">{page.title}</h1>
      )}

    
      {page.introductionAudio && (
        <div className="mb-6">
          <IntroductionAudio
            audio={page.introductionAudio}
            autoPlay={page.introductionAudio.autoPlay}
          />
        </div>
      )}

     
      {page.blocks && page.blocks.map((block) => {
        switch (block.type) {
          case 'sub-header':
            return (
              <h2
                key={block.id}
                className={`text-${block.style?.fontSize || '2xl'} font-${block.style?.fontWeight || 'bold'} text-${block.style?.color || 'gray-800'} mb-4`}
              >
                {block.text}
              </h2>
            );
          
          case 'directions':
            return (
              <div
                key={block.id}
                className={`mb-6 p-4 ${block.style?.borderLeft || ''} ${block.style?.borderColor || ''} ${block.style?.padding || ''} ${block.style?.textColor || 'text-gray-800'} ${block.style?.backgroundColor || 'bg-blue-50'} rounded-lg`}
              >
                <p className="mb-2">{block.text}</p>
                {block.requirement && (
                  <p className="font-semibold">
                    {block.requirement.text}
                  </p>
                )}
              </div>
            );
          
          default:
            return (
              <div key={block.id} className="mb-4">
                {block.text}
              </div>
            );
        }
      })}
    </div>
  );
};

export default ExamIntroPage;

